export default __webpack_public_path__ + "static/media/email.06593616.svg";